<script setup>
import {ref, onBeforeMount, onUpdated} from "vue"
import {activityStateEnum} from '@/enum/activityStateEnum.js'
const props = defineProps({
  state: {
    required: true,
    type: Number,
    default: "0"
  }
})
// 展示的文本类型
const textType = ref("info")
// 状态名称
const stateName = ref("未知状态")
// 活动状态枚举
const activityState = activityStateEnum

// 执行判断
onBeforeMount(() => {
  handleEnum()
})
onUpdated(() => {
  handleEnum()
})

// 根据枚举返回状态
const handleEnum = () => {
  try {
    const enumList = activityState.find(res => res.stateId === props.state)
    stateName.value = enumList?.stateName ? enumList.stateName : "未知状态"
    switch (props.state) {
      case 1:
        textType.value = "success"
        break
      case 0:
      default:
        textType.value = "info"
        break
    }
  } catch (e) {
    console.log(e)
  }
}
</script>

<template>
  <el-text :type="textType" v-text="stateName"></el-text>
</template>

<style scoped>

</style>
